module.exports = __webpack_public_path__ + "static/media/head_light.d2241545.svg";